/** Mapping navigation (tabs) ↔ routes canoniques — les espaces sont séparés. */
import { ROUTES } from "./routes";
import type { NavTab } from "../components/layout/Sidebar";

/** Mapping tab (navigation) → route canonique. */
export function tabToRoute(tab: string): string {
  switch (tab) {
    case "dashboard":
      return ROUTES.pro.dashboard;
    case "marketplace":
    case "search":
      return ROUTES.search;
    case "profile":
      return ROUTES.pro.profile;
    case "calls":
      return ROUTES.pro.calls;
    case "voice-agent":
      return ROUTES.pro.voiceAgent;
    case "pipeline":
      return ROUTES.pro.leads;
    case "services":
      return ROUTES.pro.services;
    case "quota":
      return ROUTES.pro.usage;
    case "statistics":
      return ROUTES.pro.statistics;
    case "subscription":
      return ROUTES.pro.subscription;
    case "calendar":
      return ROUTES.pro.calendar;
    case "portfolio":
      return ROUTES.pro.portfolio;
    case "admin":
      return ROUTES.admin.root;
    case "onboarding":
      return ROUTES.pro.onboarding;
    case "settings":
      return ROUTES.pro.settings;
    case "landing":
    default:
      return ROUTES.home;
  }
}

/** Mapping route canonique → tab (état actif de la navigation). */
export function routeToTab(pathname: string): NavTab {
  // Espace client /app : la Sidebar client n'a que ces onglets ; le reste
  // (demandes, favoris…) surligne « dashboard » qui pointe vers /app.
  if (pathname === "/app" || pathname.startsWith("/app/dashboard")) return "dashboard";
  if (pathname.startsWith("/app/profil")) return "profile";
  if (pathname.startsWith("/app/parametres")) return "settings";
  if (pathname.startsWith("/app")) return "dashboard";
  if (pathname.startsWith("/pro/appels")) return "calls";
  if (pathname.startsWith("/pro/opportunites")) return "pipeline";
  if (pathname.startsWith("/pro/agent-vocal")) return "voice-agent";
  if (pathname.startsWith("/pro/services")) return "services";
  if (pathname.startsWith("/pro/realisations")) return "portfolio";
  if (pathname.startsWith("/pro/calendrier")) return "calendar";
  if (pathname.startsWith("/pro/statistiques")) return "statistics";
  if (pathname.startsWith("/pro/abonnement")) return "subscription";
  if (pathname.startsWith("/pro/consommation")) return "quota";
  if (pathname.startsWith("/pro/onboarding")) return "onboarding";
  if (pathname.startsWith("/pro/parametres")) return "settings";
  if (
    pathname.startsWith("/professionnels/") ||
    pathname.startsWith("/pro/profil")
  )
    return "profile";
  if (pathname.startsWith("/pro")) return "dashboard";
  if (pathname.startsWith("/admin")) return "admin";
  if (pathname.startsWith("/rechercher")) return "marketplace";
  if (pathname === "/") return "landing";
  return "landing";
}
